module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sunCare@2x_c9c193.png";